export const Allstates = [
  'Andaman',
  'Char Dham',
  'Goa',
  'Golden Triangle',
  'Kerala',
  'Ladakh',
  'North East',
  'Himachal',
  'Kashmir',
  'Rajasthan',
  'Sikkim - Darjeeling',
  'Bangalore',
  'Chennai',
  'Hyderabad',
  'Lucknow',
  'Mumbai',
  'New Delhi',
  'Pune',
  'Others',
  'Gujarat',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Bihar',
  'Punjab',
  'Tamil Nadu',
  'Karnataka',
  'Odisha',
  'Maharashtra'
  ];
  